import { FC } from "react";

import { AverageConsumptionLineChart, AverageConsumptionDataPoint } from "../AverageConsumptionLineChart/AverageConsumptionLineChart";
import { AVERAGE_ENERGY_CONSUMPTION_DISHWASHERS_DATA_KEYS } from "./AverageEnergyConsumptionDishwashers.const";

const AverageEnergyConsumptionDishwashers: FC<{ data: AverageConsumptionDataPoint[] }> = ({ data }) => (
	<AverageConsumptionLineChart
		data={data}
		yAxisLabel="Average energy consumption of dishwashers"
		chartSubtitle="(kWh per cycle)"
		yDomain={[0, 2]}
		yTickCount={5}
		dataKeys={AVERAGE_ENERGY_CONSUMPTION_DISHWASHERS_DATA_KEYS}
	/>
);

export { AverageEnergyConsumptionDishwashers };
